import type { CategoryNode } from "../types/productTaxonomyApiTypes";

/**
 * Recursively finds a category by its ID within the pre-built tree structure.
 *
 * @param id - The ID of the category to find.
 * @param tree - The array of category nodes to search through.
 * @returns The found category node or null if not found.
 */
export const findCategoryInTree = (
  id: number,
  tree: CategoryNode[],
): CategoryNode | null => {
  for (const category of tree) {
    if (category.id === id) {
      return category;
    }
    const foundInChildren = findCategoryInTree(id, category.children);
    if (foundInChildren) {
      return foundInChildren;
    }
  }
  return null;
};

/**
 * Recursively gets all descendant IDs (children, grandchildren, etc.) of a specific node.
 * Used for hierarchical filter deselection logic.
 *
 * @param category - The starting category node.
 * @returns A flat array of all descendant IDs.
 */
export const getDescendantIds = (category: CategoryNode): number[] => {
  let ids = category.children.map((child) => child.id);
  category.children.forEach((child) => {
    ids = [...ids, ...getDescendantIds(child)];
  });
  return ids;
};
